/**
 * Sidebar del Super Admin — mismo shell que el resto del producto (Polaris
 * `<Navigation>`), calcado del patrón de `AdsNavigation`/`CallCenterNavigation`
 * ("módulo-as-app", NO un sidebar custom). Vive dentro del `<Frame>` que arma
 * `AdminLoginGate`. La sección activa se decide por la URL (/admin, /admin/clientes…),
 * en línea con `activeSection` de `SuperAdminPage`.
 */
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/lib/polaris';
import {
  CashDollarIcon,
  PersonIcon,
  PackageIcon,
  SettingsIcon,
  LinkIcon,
  LightbulbIcon,
} from '@/lib/polaris-icons';

export const SUPER_ADMIN_ROUTES = {
  negocio: '/admin',
  clientes: '/admin/clientes',
  planes: '/admin/planes',
  propuestas: '/admin/propuestas',
  integraciones: '/admin/integraciones',
  configuracion: '/admin/configuracion',
} as const;

export function SuperAdminNavigation() {
  const location = useLocation();
  const path = (location.pathname || '/admin').replace(/\/+$/, '') || '/admin';

  const mk = (url: string, label: string, icon: typeof CashDollarIcon) => ({
    url,
    label,
    icon,
    // "Mi negocio" (/admin) es prefijo de las demás → match exacto; el resto por prefijo.
    matches: url === '/admin' ? path === '/admin' : path === url || path.startsWith(url + '/'),
  });

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        title="Super Admin"
        items={[
          mk(SUPER_ADMIN_ROUTES.negocio, 'Mi negocio', CashDollarIcon),
          mk(SUPER_ADMIN_ROUTES.clientes, 'Clientes', PersonIcon),
          mk(SUPER_ADMIN_ROUTES.planes, 'Planes', PackageIcon),
          mk(SUPER_ADMIN_ROUTES.propuestas, 'Propuestas', LightbulbIcon),
        ]}
      />
      <Navigation.Section
        title="Sistema"
        separator
        items={[
          mk(SUPER_ADMIN_ROUTES.integraciones, 'Integraciones', LinkIcon),
          mk(SUPER_ADMIN_ROUTES.configuracion, 'Configuración', SettingsIcon),
        ]}
      />
    </Navigation>
  );
}
